// extracted by mini-css-extract-plugin
export default {"shell":"LocationPickerScreen_shell__9guSl","card":"LocationPickerScreen_card__H69Og","cardSelected":"LocationPickerScreen_cardSelected__IyXZm"};